import React from 'react';

const CoveragesSVG = ({ color, width, height }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width ? width : '24'}
    height={height ? height : '24'}
    viewBox="0 0 24 24"
  >
    <path
      fill={color ? color : '#ffffff'}
      fillRule="evenodd"
      d="M12,9 L16,9 C16.55,9 17,8.55 17,8 C17,7.45 16.55,7 16,7 L12,7 C11.45,7 11,7.45 11,8 C11,8.55 11.45,9 12,9 Z M12,13 L16,13 C16.55,13 17,12.55 17,12 C17,11.45 16.55,11 16,11 L12,11 C11.45,11 11,11.45 11,12 C11,12.55 11.45,13 12,13 Z M12,17 L16,17 C16.55,17 17,16.55 17,16 C17,15.45 16.55,15 16,15 L12,15 C11.45,15 11,15.45 11,16 C11,16.55 11.45,17 12,17 Z M7,7 L9,7 L9,9 L7,9 L7,7 Z M7,11 L9,11 L9,13 L7,13 L7,11 Z M7,15 L9,15 L9,17 L7,17 L7,15 Z M20,3 L4,3 C3.45,3 3,3.45 3,4 L3,20 C3,20.55 3.45,21 4,21 L20,21 C20.55,21 21,20.55 21,20 L21,4 C21,3.45 20.55,3 20,3 Z M19,19 L5,19 L5,5 L19,5 L19,19 Z"
    />
  </svg>
);

export default CoveragesSVG;
